import { render, staticRenderFns } from "./AddGroupMemberDialog.vue?vue&type=template&id=f536e0d4&scoped=true&"
import script from "./AddGroupMemberDialog.vue?vue&type=script&lang=js&"
export * from "./AddGroupMemberDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddGroupMemberDialog.vue?vue&type=style&index=0&id=f536e0d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f536e0d4",
  null
  
)

export default component.exports